/* Dark mode and the privacy blur, ported from artifact-v2.html.

   The theme is remembered between visits. The blur deliberately is not: it exists for
   sharing a screen or recording a demo, and should not silently persist afterwards. */

import { $ } from "./util.js";

const THEME_KEY = "oqc-theme";

export function applyTheme(theme) {
  document.documentElement.dataset.theme = theme;
  const button = $("tgl-theme");
  if (button) {
    button.textContent = theme === "dark" ? "Light" : "Dark";
    button.classList.toggle("on", theme === "dark");
  }
}

function storedTheme() {
  try { return localStorage.getItem(THEME_KEY); } catch { return null; }
}

export function initTheme() {
  applyTheme(storedTheme() || "light");

  $("tgl-theme")?.addEventListener("click", () => {
    const next = document.documentElement.dataset.theme === "dark" ? "light" : "dark";
    try { localStorage.setItem(THEME_KEY, next); } catch { /* storage blocked */ }
    applyTheme(next);
  });

  $("tgl-blur")?.addEventListener("click", () => {
    document.body.classList.toggle("pblur");
    $("tgl-blur").classList.toggle("on", document.body.classList.contains("pblur"));
  });
}
